import { FacilityStatus } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const FacilityStatusOptions = convertMapToOpts(
  FacilityStatus,
  ([_, value]) => toTitleCaseString(value)
);
